<template>
    <div class="list-container">
        <editable-list v-if="data"
                       :data="data"
                       :template="template"
                       @save-parent="save"/>
    </div>
</template>

<script>
	import NewsService from "../services/NewsService";
	import ListMixin from "../mixins/ListMixin";

	export default {
		name: "Newsroom",
		mixins: [ListMixin],
		data() {
			return {
				template: {
					_id: "",
                    id: 0,
					lang: 0,
					date: () => new Date().toISOString(),
					title: "",
					markdown: ""
				},
                backend: NewsService
			};
		}
	}
</script>

<style scoped lang="scss">
    .list-container {
        display: flex;
        position: relative;
        flex-direction: row;
        height: 100vh;
        overflow-y: hidden;
    }
</style>